// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { MetricDataType, _throwInternal } from "@microsoft/applicationinsights-core-js";
import { _DYN_BASE_TYPE, _DYN_SAMPLE_RATE } from "../__DynamicConstants";
import { createSamplingScoreGenerator } from "./SamplingScoreGenerators/SamplingScoreGenerator";
function _isSampledIn(envelope, samplingPercentage, scoreGenerator) {
    var isSampledIn = false;
    if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
        isSampledIn = true;
    }
    else if (envelope[_DYN_BASE_TYPE /* @min:%2ebaseType */] === MetricDataType) {
        // exclude MetricData telemetry from sampling
        isSampledIn = true;
    }
    if (!isSampledIn) {
        isSampledIn = scoreGenerator.getScore(envelope) < samplingPercentage;
    }
    return isSampledIn;
}
export function createSampler(sampleRate, logger) {
    var _samplingScoreGenerator = createSamplingScoreGenerator();
    if (sampleRate > 100 || sampleRate < 0) {
        _throwInternal(logger, 2 /* eLoggingSeverity.WARNING */, 58 /* _eInternalMessageId.SampleRateOutOfRange */, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
        sampleRate = 100;
    }
    var sampler = {
        sampleRate: sampleRate,
        generator: _samplingScoreGenerator,
        isSampledIn: function (envelope) {
            return _isSampledIn(envelope, sampler[_DYN_SAMPLE_RATE /* @min:%2esampleRate */], sampler.generator);
        }
    };
    return sampler;
}
//# sourceMappingURL=Sample.js.map